module.exports = __webpack_public_path__ + "static/media/olde-Orchard.f4f00db5.pdf";